import { mapActions } from 'vuex';
import authenticator from '@/authenticator/password';
import User from '@/models/core/User';
import Card from '@/components/Card/Card';
import Input from '@/components/Input/Input';
import Button from '@/components/Button/Button';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';

export default {
  name: 'login',
  components: {
    Card,
    Input,
    Button,
    ToastWrapper
  },
  props: [],
  data() {
    return {
      email: '',
      password: '',
      isRunning: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions({
      _login: 'context/login',
      _newToast: 'toasts/_addToast',
      _getUser: 'entities/users/get',
      _getFeatures: 'entities/features/init'
    }),
    login(e, username, password) {
      e.preventDefault();
      this.isRunning = true;

      authenticator
        .login({ username, password })
        .then(() => {
          const getUser = new Promise(resolve => {
            this._getUser().then(() => {
              this._getFeatures().then(() => {
                resolve();
              });
            });
          });

          return getUser;
        })
        .then(() => {
          this._newToast({
            text: 'Welcome, you will be redirected to the dashboard',
            variant: 'good',
            duration: 1000
          });

          setTimeout(() => {
            this.$router.push({ path: '/admin' });
          }, 500);
        })
        .catch(error => {
          this._newToast({
            text: 'An error occured while trying to login, so you know',
            variant: 'danger',
            duration: 2000
          });
        })
        .finally(() => {
          this.isRunning = false;
        });
    }
  }
};
